import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ChatFile, Message } from '../../../core/models/api.models';
import { MarkdownContent } from '../markdown-content/markdown-content';
import { MessageReferencesComponent } from '../message-references/message-references';
@Component({ selector: 'app-assistant-message', standalone: true, imports: [DatePipe, MarkdownContent, MessageReferencesComponent, TranslocoPipe], templateUrl: './assistant-message.html' })
export class AssistantMessage {
  @Input({ required: true }) message!: Message; @Output() copyRequested = new EventEmitter<string>(); @Output() reaction = new EventEmitter<{ message: Message; reaction: 1 | 2 }>(); @Output() reference = new EventEmitter<ChatFile>();
}
